import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import LoginHero from "../../assets/heroes/login-hero.png";
import { useForm } from "react-hook-form";
import AppInput from "../../components/forms/AppInput";
import ChangeLangButton from "../../components/language/ChangeLangButton";
import { ToastContext } from "../../App";
import React, { useState } from "react";
import { ApiResponse } from "../../api/apiResponse";
import { login } from "../../api/endpoints/auth";
import {
  clearAuthCredentials,
  setAuthCredentialsFromApiResponse,
} from "../../api/helpers/authHelpers";
import LoadingSpinner from "../../components/LoadingSpinner";
import AppLogo from "../../components/AppLogo";
import { useAuth } from "../../context/AuthContext";
import SessionsInProgressCard from "../../components/sessions/SessionsInProgressCard";

function LoginPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const Context = useAuth();
  const toastContext = React.useContext(ToastContext);
  //   TODO:  use navigate
  const LocalBasePath = "page.login";
  //   TO USE FOR TRANSLATION:  {t(`${LocalBasePath}.`)} replace your key after dot
  const onLogin = async ({
    email,
    password,
  }: {
    email: string;
    password: string;
  }) => {
    setIsLoading(true);
    clearAuthCredentials();
    const response: ApiResponse = await login(email, password);
    if (response.isSuccess) {
      setAuthCredentialsFromApiResponse(response);
      await Context?.fetchCurrentUser();
      navigate(`/`, { state: { from: "/login" } });
      toastContext?.success("loginSuccessfully");
    } else {
      toastContext?.error("loginFailed");
    }
    setIsLoading(false);
  };
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data: any) => {
    onLogin(data);
  };

  return (
    <>
      <div className="min-h-screen flex">
        <div className="flex-1 flex flex-col justify-between  py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="h-5"></div>
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
              <AppLogo />
              <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
                {t(`${LocalBasePath}.login`)}
              </h2>
            </div>
            <div className="mt-8 ">
              <div className="mt-6">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="space-y-6">
                    <div>
                      <AppInput
                        label={t(`${LocalBasePath}.email`)}
                        id="email"
                        type="email"
                        autoComplete="email"
                        placeholder={t(`${LocalBasePath}.email`)}
                        error={errors.email}
                        name="email"
                        register={register}
                        scehema={{
                          required: true,
                          pattern: /^\S+@\S+$/i,
                        }}
                      />
                    </div>

                    <div className="space-y-1">
                      <AppInput
                        label={t(`${LocalBasePath}.password`)}
                        id="password"
                        placeholder={t(`${LocalBasePath}.password`)}
                        type="password"
                        error={errors.password}
                        name="password"
                        autoComplete="current-password"
                        register={register}
                        scehema={{
                          required: true,
                          minLength: 6,
                        }}
                      />
                    </div>

                    <div className="flex items-center justify-between">
                      <div className="text-sm">
                        <Link
                          data-cy="forgot-password-link"
                          to={"/forgot-password"}
                          className="font-medium text-brandblue-600 hover:text-brandblue-500"
                        >
                          {t(`${LocalBasePath}.forgotPassword`)}
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="mt-12">
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-brandblue-600 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
                    >
                      {t(`${LocalBasePath}.signIn`)}
                      {isLoading && (
                        <span className="ms-2">
                          <LoadingSpinner size={15} />
                        </span>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <ChangeLangButton />
        </div>
        <div className="hidden lg:block relative w-0 flex-1">
          <img
            className="absolute inset-0 h-full w-full object-cover"
            src={LoginHero}
            alt=""
          />
        </div>
      </div>
    </>
  );
}
export default LoginPage;
